import EuDutyModalSkeleton from './EuDutyModalSkeleton';

export default EuDutyModalSkeleton;
